import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        home: "Home",
        about: "About",
        properties: "Properties",
        contact: "Contact",
        language: "Language",
      },
    },
    fr: {
      translation: {
        home: "Accueil",
        about: "À propos",
        properties: "Propriétés",
        contact: "Contact",
        language: "Langue",
      },
    },
  },
  lng: localStorage.getItem("lang") || "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
